module.exports = __webpack_public_path__ + "static/media/SAMSARA.54969bcf.jpg";